import { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { PersonalCalendar } from './personalCalendar.jsx'
import { PersonalCalendarHeader } from './personalCalendarHeader.jsx'
import { TeamCalendar } from './teamCalendar.jsx'

export const PersonalCalendarTabs = () => {
	const { t } = useTranslation()
	const [key, setKey] = useState('personal')

	return (
		<>
			<PersonalCalendarHeader tab={key} />
			<Tabs
				activeKey={key}
				onSelect={setKey}
				mountOnEnter={true}
				unmountOnExit={false}
				style={{ borderBottom: 'none' }}
			>
				<Tab eventKey="personal" title={t('Calendar', 'Kalenteri')}>
					<PersonalCalendar />
				</Tab>
				<Tab eventKey="team" title={t('Team', 'Tiimi')}>
					<TeamCalendar />
				</Tab>
			</Tabs>
		</>
	)
}
